module.exports = __webpack_public_path__ + "static/media/Coaching.9b9ae3a4.png";